import * as t from './actionTypes';

const initialState = { chats: [] };

const chatReducer = (state = initialState, action) => {
  switch (action.type) {
    // chat load success
    case t.CHAT_LOAD_SUCCESS:
      // snapshot value
      let chats = action.chats;
      if (!chats) {
        chats = [];
      }
      // set up and return state
      state = Object.assign({}, state, { chats: chats });
      return state;
    default:
      return state;
  }
};

export default chatReducer;
